import { Component, OnInit, Output, Inject, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'app-action-confirmation-modal',
  templateUrl: './action-confirmation-modal.component.html',
  styleUrls: ['./action-confirmation-modal.component.scss']
})
export class ActionConfirmationModalComponent implements OnInit {

  modalHeader: String;
  modalBodyText: String;
  modalBtnConfirm: String;
  modalBtnCancel: String;
  allowDelete: boolean;

  @Output()
  confirmationAction = new EventEmitter();

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private _modalService: ModalService) {
    this.modalHeader = data.data.headerText;
    this.modalBodyText = data.data.bodyText;
    this.modalBtnConfirm = data.data.btnConfirm;
    this.modalBtnCancel = data.data.btnCancel;
    this.allowDelete = data.data.allowDelete ? data.data.allowDelete : false;
   }

  ngOnInit() {}

  confirm(event: any) {
    let eventPayload = {
      sourceComponent: this.data.data.sourceComponent,
      event: event
    };
    this._modalService.close(eventPayload);
  }

  cancel(event: any) {
    let eventPayload = {
      sourceComponent: this.data.data.sourceComponent,
      event: event
    };
   this._modalService.close(eventPayload)
  }

}
